exports = module.exports = require("../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2h7-dUuWv3Lk0Szal_ORTq{\n    position: fixed;\n    width: 100%;\n    top: 50px;\n    background-color: white;\n    height: 40px;\n    z-index: 100;\n}", ""]);

// exports
exports.locals = {
	"group": "_2h7-dUuWv3Lk0Szal_ORTq"
};